import { RobotPosition, RobotProblem, RobotSkinResource } from '../robot.types';

export const cells = (n: number) => `calc(var(--cell-size) * ${n})`;

export const cellPosition = (pos: RobotPosition, scale = 1) => ({
    transform: `translate(${cells(pos.n)}, ${cells(pos.m)}) scale(${scale})`,
});

function url(image?: string | null) {
    return image ? `url('${image}')` : '';
}

export function getResourceUrl(
    resources?: RobotProblem['resources'],
    skinResource?: RobotSkinResource
): string | undefined {
    const id = skinResource?.resource_id;

    if (id && resources?.[id]) {
        return url(resources[id].file);
    }

    if (skinResource?.resource_url) {
        return url(skinResource.resource_url);
    }

    return undefined;
}

export const px = (n?: number) => (typeof n === 'number' ? `${n}px` : n);

export enum ROBOT_VIEW {
    CLASSIC = 'classic',
    LIGHT = 'light',
    NEW_YEAR = 'new-year',
    ROVER = 'rover',
    ROVER_V2 = 'rover-v2',
    ROVER_FACELESS = 'rover-faceless',
    ROVER_NEW_YEAR = 'rover-new-year',
}

export const getRobotView = (
    robotView: string | undefined | null,
    options?: { isLightEditor?: boolean }
): ROBOT_VIEW => {
    const defaultView = options && options.isLightEditor ? ROBOT_VIEW.LIGHT : ROBOT_VIEW.CLASSIC;

    if (!robotView) {
        return defaultView;
    }

    if (Object.values(ROBOT_VIEW).includes(robotView as ROBOT_VIEW)) {
        return robotView as ROBOT_VIEW;
    }

    return defaultView;
};
